module.exports = __webpack_public_path__ + "static/img/icon_user_certify.bad0f457.png";